import useRequestTable from 'app/hooks/useRequestTable'

import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    LaneFee,
} from 'app/Apps/Pricing/Pricing.types'
import requests from 'app/requests/LoggerPairing.requests'

export default (serialNumber) => {
    const {
        onParamsChange,
        isDataReady,
        refetch,
        data,
        loadData,
    } = useRequestTable<LaneFee>({
        key: RequestKeys.getDeletedLoggerHistory,
        params: {
            serialNumber,
        },
        config: requests[RequestKeys.getDeletedLoggerHistory],
        keepPreviousData: true,
    })

    return {
        onParamsChange,
        isDataReady,
        refetch,
        data,
        loadData,
    }
}
